import { useHighlight } from './useHighlight';
import { useLoadingStudy } from './useLoadingStudy';

const hooks = {
  useHighlight,
  useLoadingStudy,
};

export default hooks;
